import { Box } from '@chakra-ui/react';
import React from 'react';

export const CategoriesIcon: React.FC<{ size?: string; color?: string }> = ({
  size = '20px',
  color = 'gray.600',
}) => {
  return (
    <Box
      boxSize={size}
      display="grid"
      gridTemplateColumns="1fr 1fr"
      gridTemplateRows="1fr 1fr"
      gap="2px"
    >
      <Box bg={color} w="100%" h="100%" />
      <Box bg={color} w="100%" h="100%" />
      <Box bg={color} w="100%" h="100%" />
      <Box bg={color} w="100%" h="100%" />
    </Box>
  );
};
